import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

export default function IssueBook() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [students,        setStudents]        = useState([]);
  const [copies,          setCopies]          = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedCopy,    setSelectedCopy]    = useState("");
  const [dueDate,         setDueDate]         = useState("");
  const [saving,          setSaving]          = useState(false);

  const loadData = async () => {
    try {
      const [sRes, cRes] = await Promise.all([
        API.get("/school-admin/students/", { headers: { "X-SCHOOL-ID": school.school.id } }),
        API.get("/school-admin/library/available-copies/", { headers: { "X-SCHOOL-ID": school.school.id } }),
      ]);
      setStudents(sRes.data.students || []);
      setCopies(cRes.data.copies || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { loadData(); }, []);

  const handleIssue = async (e) => {
    e.preventDefault();
    if (!selectedStudent || !selectedCopy || !dueDate)
      return alert("Select student, book copy and due date");
    try {
      setSaving(true);
      await API.post(
        "/school-admin/library/issues/",
        { student: selectedStudent, book_copy: selectedCopy, due_date: dueDate },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      setSelectedCopy(""); setSelectedStudent(""); setDueDate("");
      loadData();
      alert("Book issued successfully");
    } catch (err) { console.error(err); alert("Failed to issue book"); }
    finally { setSaving(false); }
  };

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">📤</div>
          <div>
            <h2 className="lb-hero-title">Issue Book</h2>
            <p className="lb-hero-sub">Assign an available copy to a student — {copies.length} copies available</p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-back" onClick={() => navigate("/school-admin/library")}>← Dashboard</button>
        </div>
      </div>

      <form onSubmit={handleIssue}>
        <div className="lb-form-card">
          <p className="lb-form-title">Issue Details</p>

          <div className="lb-grid-2">
            <div className="lb-field">
              <label>Student *</label>
              <select required value={selectedStudent} onChange={e => setSelectedStudent(e.target.value)}>
                <option value="">— Select Student —</option>
                {students.map(s => (
                  <option key={s.id} value={s.id}>
                    {s.name} {s.roll_number ? `(#${s.roll_number})` : ""}
                  </option>
                ))}
              </select>
            </div>
            <div className="lb-field">
              <label>Book Copy *</label>
              <select required value={selectedCopy} onChange={e => setSelectedCopy(e.target.value)}>
                <option value="">— Select Available Copy —</option>
                {copies.map(c => (
                  <option key={c.id} value={c.id}>
                    {c.book_title} – Copy {c.copy_number}
                  </option>
                ))}
              </select>
            </div>
            <div className="lb-field">
              <label>Due Date *</label>
              <input
                type="date" required
                value={dueDate}
                onChange={e => setDueDate(e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className="lb-btn-submit" disabled={saving}>
            {saving ? <><div className="lb-spinner"></div> Issuing…</> : "📤 Issue Book"}
          </button>
        </div>
      </form>

    </div>
  );
}
